module.exports = __webpack_public_path__ + "static/media/01.f98125f3.png";